export function resolveAppDomain(configuredAppDomain, variableName = 'DOMAIN') {
    const appDomain = configuredAppDomain?.trim();
    if (!appDomain) {
        throw new Error(`${variableName} must be set`);
    }
    if (!isValidHostname(appDomain)) {
        throw new Error(`${variableName} must be a valid hostname without a scheme, port, or path`);
    }
    return appDomain;
}
export function buildAppUrl(appDomain) {
    return `https://app.${resolveAppDomain(appDomain)}`;
}
export function buildMcpUrl(appDomain) {
    return `https://mcp.${resolveAppDomain(appDomain)}/mcp`;
}
export function buildAuthUrl(appDomain) {
    return `https://auth.${resolveAppDomain(appDomain)}`;
}
export function buildAppDescription(appTitle) {
    return `${appTitle} document collections workspace`;
}
function isValidHostname(value) {
    if (value.length > 253) {
        return false;
    }
    const labels = value.split('.');
    return labels.every((label) => label.length > 0 &&
        label.length <= 63 &&
        /^[a-z\d](?:[a-z\d-]*[a-z\d])?$/iu.test(label));
}
//# sourceMappingURL=app-config.js.map